import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import type { TextFieldProps } from "@mui/material/TextField";
import TextField from "@mui/material/TextField";
import { forwardRef, useState } from "react";

type Props = Omit<TextFieldProps, "type">;

const HidenTextField = forwardRef<HTMLDivElement, Props>(function HidenTextField(
  props,
  ref
): React.JSX.Element {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = (): void => {
    setShowPassword((show) => !show);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ): void => {
    event.preventDefault();
  };

  return (
    <TextField
      {...props}
      ref={ref}
      InputProps={{
        ...(props.InputProps ?? {}),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              edge="end"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      label={props.label}
      sx={{
        "& .MuiFormLabel-root": {
          color: "primary.main",
        },
        "& .MuiInputBase-input": {
          color: "primary.main",
        },
        ...(props.sx as object),
      }}
      type={showPassword ? "text" : "password"}
    />
  );
});

export default HidenTextField;
